import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FormFieldList } from 'ngx-smart-form';
import { IconService } from '../../_core/services/icon.service';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { SharedModule } from '../../_shared/shared.module';
import { getPropertyFields } from '../add-property-dialog/property-fields';
import { Property } from '../property';

@Component({
  standalone: true,
  imports: [SharedModule],
  selector: 'app-property-table',
  templateUrl: './property-table.component.html',
  styleUrls: ['./property-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class PropertyTableComponent {
  @Input() properties: Property[] = [];
  @Output() selectedProperty = new EventEmitter<Property>();
  @Output() onDeleteProperty = new EventEmitter<Property>();

  displayedColumns: (keyof Property | 'actions')[] = [
    'tipo',
    'comune',
    'valoreStimato',
    'percentuale',
    'gravame',
    'debito',
    'actions',
  ];

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    public praticaService: PraticaProgressService,
    private iconService: IconService
  ) {
    this.iconService.getIcons(['delete', 'edit']);
  }

  patchForm(element: Property) {
    this.selectedProperty.emit(element);
    this.cdr.detectChanges();
  }

  deleteProperty(element: Property) {
    this.onDeleteProperty.emit(element);
    this.cdr.detectChanges();
  }
}
